import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://grimmenstein.dev";

interface SeoProps {
  lang: "de" | "en";
  title: string;
  description: string;
  /** Path without language prefix, e.g. "/" or "/contact" */
  path: string;
  /** Set to false for pages that only exist in German (e.g. Impressum) */
  translated?: boolean;
  keywords?: string;
}

const Seo: React.FC<SeoProps> = ({
  lang,
  title,
  description,
  path,
  translated = true,
  keywords,
}) => {
  const dePath = path === "/" ? "/" : path;
  const enPath = path === "/" ? "/en" : `/en${path}`;
  const canonical = `${SITE_URL}${lang === "en" ? enPath : dePath}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {translated && (
        <>
          <link rel="alternate" hrefLang="de" href={`${SITE_URL}${dePath}`} />
          <link rel="alternate" hrefLang="en" href={`${SITE_URL}${enPath}`} />
          <link
            rel="alternate"
            hrefLang="x-default"
            href={`${SITE_URL}${dePath}`}
          />
        </>
      )}
    </Helmet>
  );
};

export default Seo;
